import {EventFilter, Event} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const eventsGet = (filter: EventFilter) => baseRequestService<Event[]>({
    url: '/events',
    method: 'GET',
    params: { filter }
})